import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import GoogleMaterialIcon from '@/components/icons/google-material-icon/google-material-icon';
import PerformanceProgress from '@/components/charts/performance-bar/performance-bar';
import GuestUserPop from '@/components/guest-user-pop/guest-user-pop';
import DrilldownStrugglePullup from '@/components/pull-up/drilldown-struggle-pullup/drilldown-struggle-pullup';
import { StruggleData } from '@/models/groups/report';
import { SubjectModel } from '@/models/groups/subjects';

@Component({
    name: 'network-struggling-competency-card',
    components: {
        'material-icon': GoogleMaterialIcon,
        'progress-bar': PerformanceProgress,
        'guest-popup': GuestUserPop,
        'struggle-pullup': DrilldownStrugglePullup,
    },
})

export default class NetworkStrugglingCompetencyCard extends Vue {

    // --------------------------------------------------------------------------------
    // Properties

    @Prop()
    private strugglingCompetencies!: StruggleData[];
    @Prop()
    private isTenant?: boolean;
    @Prop()
    private isDemoTenant!: boolean;
    @Prop()
    private hiddenData?: boolean;
    @Prop()
    private selectedSubject: any;
    @Prop()
    private groupType!: string;
    @Prop()
    private groupName!: string;

    @Prop()
    private subjectList?: any;

    private get isGuestUser() {
        return this.$access.isGuestUser('guest', 'guest');
    }

    private isGuestPullup: boolean = false;

    private isShowPullup: boolean = false;

    private get strugglingList() {
        return this.strugglingCompetencies.map((item: StruggleData) => item.competencies).flat(1);
    }

    private get competencyCount() {
        let count: number = 0;
        this.strugglingCompetencies.forEach((struggle: any) => {
            if (struggle.competencies.length > 0) {
                count++;
            }
        });
        return count;
    }

    // ------------------------------------------------------------------------
    // Hooks

    // -------------------------------------------------------------------------------
    // Actions
    private onShowPopup() {
        if (this.isGuestUser) {
            this.isGuestPullup = true;
            return;
        }
        if ((this.subjectList || this.subjectList.length) ||
            this.strugglingCompetencies.length && !this.$access.isDemoGroup) {
            const activeSubject = this.selectedSubject ? this.selectedSubject : null;
            this.isShowPullup = true;
        }
    }

    private onCloseTsPullup() {
        this.isGuestPullup = false;
        this.isShowPullup = false;
    }

    private onSelectStrunggleSubject(subject: any = null) {
        this.$emit('onSelectStrunggleSubject', subject);
    }

    // -------------------------------------------------------------------------------
    // Methods


}
